exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fontStyle[data-v-43268701]{font-size:12px}.errorStyle[data-v-43268701]{font-weight:bolder;color:red}.card[data-v-43268701]{background:#fff;border-radius:10px;transition:.3s ease-in-out}.card-body[data-v-43268701]{padding:0!important}.card[data-v-43268701]:hover{transform:translateY(-3px);box-shadow:0 4px 8px rgba(0,0,0,.2)}h6[data-v-43268701]{margin-bottom:5px;color:#333}p[data-v-43268701]{margin-bottom:10px;font-size:14px;color:#555}", ""]);

// exports
